import { useCallback, useEffect, useRef, useState } from "react";

export const TRACKS = [
  { id: "iron-pulse", name: "Iron Pulse · Boom bap" },
  { id: "ring-fire", name: "Ring Fire · Electro" },
  { id: "eye-of-the-gym", name: "Eye of the Gym · 80s Rock" },
  { id: "night-sparring", name: "Night Sparring · Trap" },
];

const DUCK = 0.22;

export function useMusic() {
  const [track, setTrack] = useState(() => localStorage.getItem("guardia_music_track") || TRACKS[0].id);
  const [volume, setVolume] = useState(() => Number(localStorage.getItem("guardia_music_vol") ?? 0.45));
  const [playing, setPlaying] = useState(false);
  const audio = useRef(null);
  const ducked = useRef(false);

  const apply = useCallback(() => {
    if (audio.current) audio.current.volume = Math.max(0, Math.min(1, volume * (ducked.current ? DUCK : 1)));
  }, [volume]);

  useEffect(() => {
    localStorage.setItem("guardia_music_track", track);
    const a = new Audio(`/music/${track}.mp3`);
    a.loop = true;
    audio.current = a;
    apply();
    if (playing) a.play().catch(() => setPlaying(false));
    return () => a.pause();
  }, [track]); // eslint-disable-line

  useEffect(() => { localStorage.setItem("guardia_music_vol", String(volume)); apply(); }, [volume, apply]);

  const play = useCallback(() => { audio.current?.play().then(() => setPlaying(true)).catch(() => setPlaying(false)); }, []);
  const pause = useCallback(() => { audio.current?.pause(); setPlaying(false); }, []);
  const duck = useCallback((on) => { ducked.current = on; apply(); }, [apply]);

  return { track, setTrack, volume, setVolume, playing, play, pause, duck };
}
